/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Get the noreturnss tag modal and close button elements
  var modal = document.getElementById("myModal");
  var closeBtn = document.getElementsByClassName("close")[0];

  // Function to show the modal
  function showModal() {
    modal.style.display = "block";
  }

  // Function to close the modal
  function closeModal() {
    modal.style.display = "none";
  }

  // Add click event listener to the "Add to Cart" button
  try{document.getElementById("addToCartButton").addEventListener("click", showModal);}catch(err){}

  // Close the modal when clicking on the "x" button
  try{closeBtn.addEventListener("click", closeModal);}catch(err){}

  // Close the modal when clicking outside of it
  window.addEventListener("click", function(event) {
    if (event.target == modal) {
      closeModal();
    }
  });